import { Position } from '@ui/services/contract/hooks/TradingReaderFacet/useGetPositionV2/types';

import { getClosePositionFee } from './getClosePositionFee';
import { getPositionPnl } from './getPositionPnl';

/**
 *  initialCollateral = getPositionsV2.margin
 *  pnlAfterFee = pnl - fundingFee - holdingFee - closeFee
 *  net value = initialCollateral     + pnlAfterFee
 *            = getPositionsV2.margin + pnl - fundingFee - holdingFee - closeFee
 *
 *  all in usd
 */

export function getPositionNetValue({
  collateralAfterFee,
  pnl,
  closeFee,
  fundingFee,
  holdingFee,
}: {
  collateralAfterFee: ReturnType<Position['getCollateralUsd']>;
  pnl: ReturnType<typeof getPositionPnl>;
  holdingFee: ReturnType<Position['getHoldingFeeUsd']>;
  fundingFee: ReturnType<Position['getFundingFeeUsd']>;
  closeFee: ReturnType<typeof getClosePositionFee>;
}) {
  return collateralAfterFee
    .plus(pnl)
    .minus(fundingFee)
    .minus(holdingFee)
    .minus(closeFee.finalCloseFee);
}
